import React from 'react';
import './Button.css';

const Button = ({ 
    children, 
    onClick, 
    variant = 'primary', // primary, secondary, ghost, destructive
    size = 'md', // sm, md, lg
    className = '',
    disabled = false,
    icon: Icon,
    type = 'button'
}) => {
    return (
        <button 
            type={type}
            className={`btn btn-${variant} btn-${size} ${className}`}
            onClick={onClick}
            disabled={disabled}
        >
            {Icon && <Icon size={18} className="btn-icon" />}
            {children}
        </button>
    );
};

export default Button;
